<template>
  <div>
    <div>
      <div class="max-w-5xl mx-auto mt-5">
        <div class="px-0 py-4 bg-white rounded-md shadow-sm">
          <div class="">
            <nav class="flex pb-4 border-b ">
              <router-link
                :to="{ name: 'OrdersSettingsDelivery' }"
                class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-600 rounded-md focus:outline-none focus:text-indigo-800"
              >
                Consegna a domicilio
              </router-link>
              <router-link
                :to="{ name: 'OrdersSettingsTakeAway' }"
                class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-600 rounded-md focus:outline-none focus:text-indigo-800"
              >
                Asporto
              </router-link>
              <router-link
                :to="{ name: 'OrdersSettingsTable' }"
                class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-600 rounded-md focus:outline-none focus:text-indigo-800"
              >
                Tavolo
              </router-link>
              <router-link
                :to="{ name: 'OrdersSettingsHotel' }"
                class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-600 rounded-md focus:outline-none focus:text-indigo-800"
              >
                Hotel
              </router-link>
              <router-link
                :to="{ name: 'OrdersSettingsUmbrella' }"
                class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-600 rounded-md focus:outline-none focus:text-indigo-800"
              >
                Ombrellone
              </router-link>
              <router-link
                :to="{ name: 'OrdersSettingsRoomService' }"
                class="px-3 py-2 ml-4 text-sm font-medium leading-5 text-gray-600 rounded-md focus:outline-none focus:text-indigo-800"
              >
                Servizio in camera
              </router-link>
            </nav>
          </div>
          <div class="m-4 mb-0">
            <router-view :key="$route.path"></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: Number,
  },
  components: {},
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
};
</script>
